import { useGetPersonalOrderQuery } from "../../../../../../../../../services/PerformanceHistory/performanceHistoryAPI";
import { PerfHistoryDataProps } from "../ABOProfilePerfHistoryKPIs";

const ABOProfilePerfHistoryPersonalOrder = ({
  affAbo,
  locale,
  isoCountryCode,
  period,
  periodCount = 12,
  children,
}: PerfHistoryDataProps) => {
  const { isFetching, data, isError } = useGetPersonalOrderQuery({
    affAbo,
    period,
    periodCount,
    locale,
    market: isoCountryCode,
  });

  return <>{children({ data, isFetching, isError })}</>;
};

export default ABOProfilePerfHistoryPersonalOrder;
